import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../AuthContext";
import { fmtErr } from "../api";
import { AdminAuthShell } from "../components";

const Login = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AdminAuthShell>
      <div data-testid="admin-login-page">
        <form onSubmit={submit} className="bg-white p-8 rounded-sm shadow-2xl" data-testid="admin-login-form">
          <h1 className="font-display text-lg font-bold text-slate-900 flex items-center gap-2"><Lock size={16} className="text-[#C5221F]" /> Staff Sign In</h1>
          <p className="mt-1.5 text-xs text-slate-500">Authorized G. R. Engineering staff only.</p>
          <div className="mt-6 space-y-4">
            <div>
              <label htmlFor="admin-email" className="block text-[11px] font-bold uppercase tracking-widest text-slate-500 mb-1.5">Email</label>
              <input id="admin-email" type="email" required autoComplete="username" data-testid="admin-email-input"
                className="w-full border border-slate-300 px-3.5 py-2.5 text-sm rounded-sm focus:outline-none focus:border-[#C5221F] focus:ring-1 focus:ring-[#C5221F]"
                value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@grengg.com" />
            </div>
            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label htmlFor="admin-password" className="block text-[11px] font-bold uppercase tracking-widest text-slate-500">Password</label>
                <Link to="/admin/forgot-password" className="text-[11px] font-semibold text-[#C5221F] hover:underline" data-testid="forgot-password-link">Forgot Password?</Link>
              </div>
              <input id="admin-password" type="password" required autoComplete="current-password" data-testid="admin-password-input"
                className="w-full border border-slate-300 px-3.5 py-2.5 text-sm rounded-sm focus:outline-none focus:border-[#C5221F] focus:ring-1 focus:ring-[#C5221F]"
                value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••••" />
            </div>
            {error && <p className="text-xs text-[#C5221F] bg-red-50 border border-red-200 px-3 py-2.5 rounded-sm" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={busy} data-testid="admin-login-submit-btn"
              className="w-full bg-[#C5221F] hover:bg-[#A81B18] disabled:opacity-60 text-white font-display font-semibold py-3 text-xs uppercase tracking-widest rounded-sm transition-colors duration-150 inline-flex items-center justify-center gap-2">
              {busy && <Loader2 size={14} className="animate-spin" />} Sign In
            </button>
          </div>
        </form>
        <p className="mt-6 text-center text-[11px] text-slate-300">Failed attempts are logged and rate-limited.</p>
      </div>
    </AdminAuthShell>
  );
};

export default Login;
